import { type Ref } from 'react';
import { Focusable, Avatar as LaunchpadAvatar, Tooltip, TooltipTrigger } from '@launchpad-ui/components';

import { getGravatarUrl } from '../../utils';

type AvatarProps = Readonly<{
  email: string;
  size?: 'small' | 'medium' | 'large';
  ref?: Ref<HTMLDivElement>;
}>;

export const Avatar = ({ email, size = 'medium', ref }: AvatarProps) => (
  <TooltipTrigger>
    <Focusable>
      <div ref={ref} role="img" aria-label={`Avatar for ${email}`} style={{ display: 'inline-block' }}>
        <LaunchpadAvatar src={getGravatarUrl(email)} size={size} />
      </div>
    </Focusable>
    <Tooltip placement="bottom" variant="popover">
      {email}
    </Tooltip>
  </TooltipTrigger>
);
